var map = {
	"./bcn-logo-mobile.svg": 6513,
	"./bcn-logo.svg": 65778,
	"./canals.jpg": 69806,
	"./category-1111.jpg": 53837,
	"./category-1112.jpg": 24578,
	"./category-1113.jpg": 37247,
	"./category-1460.jpg": 67864,
	"./category-1461.jpg": 75733,
	"./category-1462.jpg": 49482,
	"./districte-1.jpg": 71369,
	"./districte-10.jpg": 19445,
	"./districte-2.jpg": 81310,
	"./districte-3.jpg": 52443,
	"./districte-4.jpg": 29768,
	"./districte-5.jpg": 92133,
	"./districte-6.jpg": 69530,
	"./districte-7.jpg": 63991,
	"./districte-8.jpg": 82628,
	"./districte-9.jpg": 60673,
	"./favicon.png": 87844,
	"./heading-icon.svg": 59085,
	"./logo-ajbcn.svg": 96745,
	"./logo-negre.svg": 5482,
	"./logo.svg": 51792,
	"./logo_decidim.png": 81487,
	"./pattern-big.svg": 34312,
	"./pattern.svg": 3485,
	"./trobades.jpg": 1280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71027;